import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  currentValidAustralianAddress: () =>
    i18n.t(i18nKeys.address__history__currentValidAustralianAddress),
  anotherPreviousAddress: () =>
    i18n.t(i18nKeys.address__history__anotherPreviousAddress),
  continue: () => i18n.t(i18nKeys.address__history__continue),
  yearsAndMonthsAdded: (years, months) =>
    i18n.t(i18nKeys.address__history__yearsAndMonthsAdded, { years, months }),
  fiveYearsOfAddressesError: () =>
    i18n.t(i18nKeys.address__history__fiveYearsOfAddressesError),
}
